<div
  class="
"
>
  <div class="mb-4 flex justify-end">
    <button mat-raised-button class="btn-add" (click)="newItem()">
      Inserir
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <div class="mt-4">
    <!--    @if (checkPermission('pesquisar-paginado')) {-->
    <!--      <form-search [search]="inputSearch" (responseSearch)="search($event)" />-->
    <!--    }-->
    <div>
      @if (!loading) {
        <div>
          <table-list-tariff
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="editItem($event)"
            (deleteItem)="deleteItem($event)"
          />
          @if (itemsList.length > 0) {
            <pagination
              [currentPage]="page"
              [pageSize]="rows"
              [totalRecords]="numberRows"
              (pageChanged)="pageChanged($event)"
            />
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
